export default __webpack_public_path__ + "static/media/loader.103eb855.gif";